import type { MouseEventHandler } from "react";
import Touchable from "src/components/Touchable";
import { X } from "src/icons";

import { cn } from "src/utilities/shadcnUtils";

interface XButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  color?: string;
}

const XButton = ({ onClick, color, className }: XButtonProps) => (
  <Touchable
    className={cn("bg-border text-muted-foreground/70 h-[52px] w-[52px] rounded-full", className)}
    onClick={onClick}
  >
    <X strokeWidth="3" height={20} width={20} color={color} />
  </Touchable>
);

export default XButton;
